import {NavLink} from "react-router-dom";
import React, {useState} from "react";
import {OptiselEventJson} from "./OptiselEventHistoryPage";
import {OptiselEventSummarization} from "./OptiselEventSummarization";
import {OptiselEventNoteEditor} from "./OptiselEventNoteEditor";

const TYPES_WITHOUT_ROW_ACTIONS = new Set([
    "issue-created",
    "issue-reference-information-updated",
    "issue-assignee-change",
    "issue-archived",
    "issue-restored-from-archive",
]);

function formatFanSelectionOrderNumber(orderNumber: number): string {
    return String(orderNumber).padStart(2, "0");
}

export function OptiselEventTable({results, additionalActionComponents, fanSelectionOrderNumberByEventId}: {
    results: OptiselEventJson[],
    additionalActionComponents?: (eventId: string) => JSX.Element,
    fanSelectionOrderNumberByEventId?: Record<string, number>
}) {
    const [noteOverrides, setNoteOverrides] = useState<Record<string, string>>({});

    const rememberNoteOverride = (eventId: string, newNote: string) => {
        setNoteOverrides(prev => ({...prev, [eventId]: newNote}));
    };

    if ( results.length === 0 ) {
        return <div className="alert alert-secondary texte-center">Brak przypisanych zdarzeń</div>;
    }
    return <table className={"table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3"}>
        <thead>
        <tr className="fw-bolder text-muted">
            <th className="w-100px">Wentylator / ID</th>
            <th className="min-w-140px">Autor / Źródło</th>
            <th className="min-w-120px">Utworzono</th>
            <th className="min-w-200px">Notatka</th>
            <th className="text-end">Akcje</th>
        </tr>
        </thead>
        <tbody>
        {results.map(result => {
            const showRowActions = !TYPES_WITHOUT_ROW_ACTIONS.has(result.type);
            const currentNote = noteOverrides[result.id] ?? result.note;
            const fanSelectionOrderNumber = fanSelectionOrderNumberByEventId?.[result.id];
            return <tr className={result.persistent ? "" : "opacity-50"}>
                <td className="align-top text-nowrap">
                    {fanSelectionOrderNumber !== undefined &&
                        <div className="fs-1 fw-boldest text-primary lh-1 mb-1">{formatFanSelectionOrderNumber(fanSelectionOrderNumber)}</div>}
                    <div className="text-gray-600 fs-8">{result.typeDisplayName}</div>
                    <div className="fw-bold">{result.discriminatorName}</div>
                    <div className="text-gray-300 fs-8">{result.id}</div>
                    <OptiselEventSummarization event={result}/>
                </td>
                <td className="align-top">
                    <div>{result.performerDisplayName}</div>
                    <div className={"text-gray-400"}>{result.sourceSystemName}</div>
                </td>
                <td className="align-top">{new Date(result.creationMillis).toLocaleString("pl")}</td>
                <td className="align-top">
                    {showRowActions && <OptiselEventNoteEditor
                        eventId={result.id}
                        initialNote={currentNote}
                        onNoteUpdated={newNote => rememberNoteOverride(result.id, newNote)}
                    />}
                </td>
                <td className="align-top text-end">
                    {showRowActions && <NavLink to={`/optisel-event/${result.id}`} className={"btn btn-sm btn-light-primary"}>Zobacz</NavLink>}
                    {showRowActions && additionalActionComponents?.(result.id)}
                </td>
            </tr>;
        })}
        </tbody>
    </table>;
}
